import { cva } from 'class-variance-authority'

import { MAX_YEAR, MIN_YEAR } from './consts'

export const getPreviousMonth = (currentMonth: Date): Date => {
  const newMonth = new Date(currentMonth)
  newMonth.setDate(1)
  newMonth.setMonth(currentMonth.getMonth() - 1)
  return newMonth
}

export const getNextMonth = (currentMonth: Date): Date => {
  const newMonth = new Date(currentMonth)
  newMonth.setDate(1)
  newMonth.setMonth(currentMonth.getMonth() + 1)
  return newMonth
}

export const getPreviousYear = (currentMonth: Date): Date => {
  const newMonth = new Date(currentMonth)
  newMonth.setFullYear(currentMonth.getFullYear() - 1)
  return newMonth
}

export const getNextYear = (currentMonth: Date): Date => {
  const newMonth = new Date(currentMonth)
  newMonth.setFullYear(currentMonth.getFullYear() + 1)
  return newMonth
}

export const getYearOptions = () =>
  Array.from({ length: MAX_YEAR - MIN_YEAR + 1 }, (_, index) => {
    const year = MIN_YEAR + index
    return { value: year, label: year }
  })

export const isSameDay = (left?: Date, right?: Date) => {
  if (!left || !right) return false
  return left.toDateString() === right.toDateString()
}

export const orderDates = (left: Date, right: Date) => {
  return left <= right ? [left, right] : [right, left]
}

export const getRangeDayState = ({
  date,
  rangeStart,
  rangeEnd,
  hoverDate,
}: {
  date: Date
  rangeStart?: Date
  rangeEnd?: Date
  hoverDate?: Date
}) => {
  if (!rangeStart && !rangeEnd && isSameDay(date, hoverDate)) return 'emptyHover'
  if (isSameDay(date, rangeStart)) return 'rangeStart'
  if (isSameDay(date, rangeEnd)) return 'rangeEnd'
  if (rangeStart && rangeEnd && date > rangeStart && date < rangeEnd) return 'inRange'

  if (rangeStart && !rangeEnd && hoverDate) {
    const [previewStart, previewEnd] = orderDates(rangeStart, hoverDate)
    if (isSameDay(date, previewStart)) return 'previewRangeStart'
    if (isSameDay(date, previewEnd)) return 'previewRangeEnd'
    if (date > previewStart && date < previewEnd) return 'previewInRange'
  }

  return 'default'
}

export const dayCellVariants = cva('', {
  variants: {
    state: {
      default: '',
      emptyHover:
        'rounded bg-main-background-interactive-list-selected [&_button]:rounded [&_button]:!bg-main-background-interactive-list-selected',
      inRange: 'rounded bg-main-background-interactive-list-selected',
      previewInRange: 'rounded bg-main-background-interactive-list-selected',
      rangeStart:
        'rounded bg-main-foreground-accent [&_button]:rounded [&_button]:!bg-main-foreground-accent [&_button]:!text-white [&_button:hover]:!bg-main-foreground-accent [&_button:hover]:!text-white',
      rangeEnd:
        'rounded bg-main-foreground-accent [&_button]:rounded [&_button]:!bg-main-foreground-accent [&_button]:!text-white [&_button:hover]:!bg-main-foreground-accent [&_button:hover]:!text-white',
      previewRangeStart:
        'rounded bg-main-background-interactive-list-selected [&_button]:rounded [&_button]:!bg-main-background-subtle-semantic-accent/60 [&_button]:!text-main-foreground-accent [&_button:hover]:!bg-main-background-subtle-semantic-accent/60 [&_button:hover]:!text-main-foreground-accent',
      previewRangeEnd:
        'rounded bg-main-background-interactive-list-selected [&_button]:rounded [&_button]:!bg-main-background-subtle-semantic-accent/60 [&_button]:!text-main-foreground-accent [&_button:hover]:!bg-main-background-subtle-semantic-accent/60 [&_button:hover]:!text-main-foreground-accent',
    },
  },
  defaultVariants: {
    state: 'default',
  },
})
